module.exports = __webpack_public_path__ + "assets/58e049550afb0d25e58683a3739826f0.jpg";